import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtServiceUtil } from './jwt-service-util.';

/**
 * Settings
 */
import { environment } from '@env/environment';
import { AuthSessionService } from '@services/auth-session.service';

/**
 * RxJs
 */
import { BehaviorSubject ,  Observable } from 'rxjs';



@Injectable()
export class AuthenticationService {
  headersToAuth: HttpHeaders;
  urlToAuth = environment.urlToApi + 'login';
  urlToApi = environment.urlToApi;
  user: any;
  bkp_token: any;
  routeCount: any = 0;
  permissions = [];

  constructor(
    private http: HttpClient,
    private authSession: AuthSessionService,
  ) {
    this.setHeaders();
  }

  setHeaders(){
    this.headersToAuth = this.authSession.buildHeaders({ Accept: 'application/json' });
  }

  // Observable  starts
  setUser = () => new Promise((resolve, reject) => {
    this.setHeaders();

    this.http
    .get(this.urlToApi + 'user', { 'headers': this.headersToAuth })
    .subscribe(res => {

      this.user = res;

      if (this.user.id) {
        resolve(this.user);
        this.authSession.setUser(this.user);
      } else {
        resolve(false);
      }
    }, error => {
      resolve(false);
    });
  })

  getUser = () => {
    return this.user;
  }
  // Observable  ends
  getUserMenu = (param) => new Promise((resolve, reject) => {
    this.setHeaders();

    this.http.post(this.urlToApi + param.route, param.data, { 'headers': this.headersToAuth })
    .subscribe(res => {
      let obj;
      obj = res;
      resolve({
        obj
      });
    }, err => {
    });
  })

  login = (params) => new Promise((resolve, reject) => {
    this.setHeaders();

    this.http
    .post<any>(
      this.urlToAuth,
      {
        'client_id': 2,
        'grant_type': 'password',
        'username': params.login.value,
        'password': params.password.value
      }, { 'headers': this.headersToAuth }
    ).subscribe(res => {
      if (res.access_token) {
        this.authSession.setAccessToken('Bearer ' + res.access_token);
        this.authSession.setApplication(res.application);
        this.authSession.setUser(res.user);
        this.authSession.setAcceptTerms(res.accept_terms);
        this.authSession.setPrivileges(res.privileges);

        resolve({
          cod: 200,
          message: 'Login feito com sucesso'
        });
      }
    }, err => {
      switch (err.status) {
        case 400:
        case 401:
          resolve({
            cod: err.status,
            message: 'CPF e/ou senha incorreto(s).'
          });
          break;
        case 403:
          resolve({
            cod: err.status,
            message: 'Usuário está inativo, entre em contato com seu interlocutor.'
          });
          break;
        case 404:
          resolve({
            cod: err.status,
            message: 'Servidor de autenticação não encontrado.'
          });
          break;
        case 0:
        case 504:
          resolve({
            cod: err.status,
            message: 'Servidor não está respondendo.'
          });
          break;

        default:
          resolve({
            cod: err.status,
            message: err.statusText ?? 'Falha no servidor.'
          });
          break;
      }
    }, () => {

    });
  })

  logout(){
    this.authSession.clear();
  }

  simulatePermission = (params) => new Promise((resolve, reject) => {
    this.bkp_token = this.authSession.getAccessToken();
    this.authSession.setBackupAccessToken('Bearer ' + this.bkp_token);

    if (!params.route) { // Verifica se pelo menos uma child foi definida
      reject({
        cod: 'c-01',
        message: 'Informar erro c-01 ao administrador'
      });
    }

    this.setHeaders();
  })

  recoverPasswordEmail = (cpf_number, birth_date) => new Promise((resolve, reject) => {
    let emailToResetPassword;
    emailToResetPassword = {
      cpf_number: cpf_number,
      birth_date: birth_date
    };
    this.http
    .post(
      this.urlToApi + 'password/reset-password',
      emailToResetPassword
    ).subscribe(res => {
      resolve({
        return: res
      });
    }, err => resolve({return: err['_body']}));
  })

  getPermissions(route, user) {
    this.user = user;
    this.permissions = [];
    const menu_rules = [];
    this.user.access_profiles.map( a => {
      a.menu_rules.map( mr => {
        if (mr.menu[0] && menu_rules.filter( i => i.name === mr.name).length === 0 && mr.rule[0].name !== 'Menu') {
          if (!this.hasAForcedRemovedRule(mr)) {
            menu_rules.push(mr);
          }
        }
      });
    });

    this.user.menu_rules.map(mr => {
      if (mr.menu[0] && menu_rules.filter( i => i.name === mr.name).length === 0 && mr.rule[0].name !== 'Menu' &&
      mr.pivot.modification === 'ADDED') {
        menu_rules.push(mr);
      }
    });

    menu_rules.filter( m => {
      if (m.menu[0].route === route) { this.permissions.push(m.rule[0].name ); }
    });
    return this.permissions;
  }

  hasAForcedRemovedRule(rule) {
    return this.user.menu_rules.filter(mr => mr.menu[0].route === rule.menu[0].route
      && mr.pivot.modification === 'REMOVED' && mr.name === rule.name).length > 0;
  }
}
